class ProductIngredients extends HTMLElement {
  constructor() {
    super();
    this.ingredientsElement = this.querySelector('[data-ingredients]');
    this.windowWidth = window.innerWidth;

    this.toggleVisibilityFirstIngredient()

    // Catch click on desktop ingredient navigation
    this.ingredientsElement.querySelectorAll('[data-ingredients-link]').forEach(link => link.addEventListener('click', this.linkClick.bind(this,event,link)));

    // Catch click on mobile ingredient navigation
    this.ingredientsElement.querySelectorAll('[data-ingredients-mobile-link]').forEach(mobLink => mobLink.addEventListener('click', this.mobLinkClick.bind(this,event,mobLink)));

  }

  toggleVisibilityFirstIngredient() {
    const IngredientElements = document.querySelectorAll('[data-ingredients-link]');
    const firstIngredientElement = IngredientElements[0];

    const IngredientElementsContent = document.querySelectorAll('[data-ingredients-content-pane]');
    const firstIngredientElementsContent = IngredientElementsContent[0];

    const IngredientElementsMobile = document.querySelectorAll('[data-ingredients-mobile-link');
    //Toggle product details ingredient visibility on desktop

    if (this.windowWidth >= 768) {
      if (firstIngredientElement && firstIngredientElementsContent) {
        firstIngredientElement.classList.add('is-active');
        firstIngredientElementsContent.classList.add('is-active');
      }
    } else {
      if (IngredientElementsMobile && IngredientElementsContent){
        IngredientElementsMobile.forEach((IngredientElementMobile) => {
          IngredientElementMobile.classList.remove('is-active');
        });
        IngredientElementsContent.forEach((IngredientElementContent) => {
          IngredientElementContent.classList.remove('is-active');
        });
      }
    }
  }

  // mobile
  mobLinkClick(event,mobLink) {
    const title = mobLink.dataset.ingredientsMobileLink;
    // Only do something when the ingredient is not active
    if (!mobLink.classList.contains('is-active')) {
      // Close the active ingredient and open the clicked ingredient after that
      this.closeActiveIngredient(title);

      // Open the clicked tag link
      this.openIngredientNavLink(title);
      this.openIngredient(title);
    } else {
      // Close the active ingredient
      this.closeCurrentIngredient(title);
    }
  }

  // desktop
  linkClick(event,link) {
    const title = link.dataset.ingredientsLink;

    // Only do something when the ingredient is not active
    if (!link.classList.contains('is-active')) {

      // Close the active ingredient and open the clicked ingredient after that
      this.closeActiveIngredient(title);

      // Open the clicked tag link
      this.openIngredientNavLink(title);
    } else {
      // Close the active ingredient
      this.closeCurrentIngredient(title);
    }
  }

  closeActiveIngredient(title) {
    const activeIngredient = this.ingredientsElement.querySelector('.is-active');
    // If there is an active ingredient
    if (activeIngredient) {
      // Get title
      const activeTitle = activeIngredient.dataset.ingredientsLink;
      // Don't reopen self
      if (activeTitle === title) {
        return;
      }

      this.closeIngredient(activeTitle);
      this.closeIngredientNavLink(activeTitle);
    }

    this.openIngredient(title);
  }

  closeCurrentIngredient(title) {
    const activeIngredient = this.ingredientsElement.querySelector('.is-active');
    // If there is an active ingredient
    if (activeIngredient) {

      // Get title
      const activeTitle = activeIngredient.dataset.ingredientsLink;

      // Close current ingredient
      this.closeIngredient(activeTitle);
    }
  }

  closeIngredient(title) {
    // Close the ingredient and ingredient link content
    this.ingredient =  this.ingredientsElement.querySelector('[data-ingredients-link="' + title + '"]');
    this.mobIngredient = this.ingredientsElement.querySelector('[data-ingredients-mobile-link="' + title + '"]');
    this.ingredientContent = this.ingredientsElement.querySelector('[data-ingredients-content-pane="' + title + '"]');
    if (this.ingredient) {
      this.ingredient.classList.remove('is-active');
      this.ingredientContent.classList.remove('is-active');
    }
    if (this.mobIngredient) {
      this.mobIngredient.classList.remove('is-active');
      this.ingredientContent.classList.remove('is-active');
    }
  }

  closeIngredientNavLink(title) {
    // Close the ingredient link in nav
    this.ingredient =  this.ingredientsElement.querySelector('[data-ingredients-link="' + title + '"]');
    this.mobIngredient = this.ingredientsElement.querySelector('[data-ingredients-mobile-link="' + title + '"]');
    if (this.ingredient) {
      this.ingredient.classList.remove('is-active');
    }
    if (this.mobIngredient) {
      this.mobIngredient.classList.remove('is-active');
    }
  }

  openIngredient(title) {
    // Open new ingredient and the ingredient content
    this.ingredientsElement.querySelector('[data-ingredients-content-pane="' + title + '"]').classList.add('is-active');
    this.ingredientsElement.querySelector('[data-ingredients-link="' + title + '"]').classList.add('is-active');
    this.ingredientsElement.querySelector('[data-ingredients-mobile-link="' + title + '"]').classList.add('is-active');
  }

  openIngredientNavLink(title) {
    // Open new ingredient
    this.ingredientsElement.querySelector('[data-ingredients-link="' + title + '"]').classList.add('is-active');
    this.ingredientsElement.querySelector('[data-ingredients-mobile-link="' + title + '"]').classList.add('is-active');
  }
}
customElements.define('product-ingredients', ProductIngredients);
